"use client";
import a from "./index.es141.js";
import n from "react";
const c = ({
  children: e,
  className: t = "",
  ...l
}) => /* @__PURE__ */ n.createElement(
  "h1",
  {
    ...l,
    className: `${t} bl-size-1 bl-p-b-7`,
    style: { textAlign: "center" }
  },
  e
);
a(c)`
  text-align: center;
`;
//# sourceMappingURL=index.es88.js.map
